import React, { useCallback, useEffect, useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  Button,
  Chip,
  IconButton,
  Tooltip,
  Typography,
  Stack,
  alpha,
} from "@mui/material";

import {
  Delete,
  SendAndArchiveSharp,
  CloudUploadOutlined,
} from "@mui/icons-material";

import { styled } from "@mui/material/styles";

import axios from "axios";
import Swal from "sweetalert2";
import { MRT_Localization_ES } from "material-react-table/locales/es";

// ----------------------------------------------------------------------
// CONSTANTES
// ----------------------------------------------------------------------

const API_URL = "https://middlewarebackprd.azurewebsites.net/api/v1";

const AUTH = {
  username: "admin.icontec@icontec.org",
  password: "quAngEraMuSTerGerEDE",
};

// ----------------------------------------------------------------------
// ESTILOS
// ----------------------------------------------------------------------

const PageContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(2),

  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(3),
  },
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "stretch",
  },
}));

const HeaderTitle = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
}));

// ----------------------------------------------------------------------
// COMPONENTE
// ----------------------------------------------------------------------

const InfoTesoreria = () => {
  const [list1, setList1] = useState([]);

  // --------------------------------------------------------------------
  // OBTENER INFORMACIÓN
  // --------------------------------------------------------------------

  useEffect(() => {
    axios({
      auth: AUTH,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: `${API_URL}/ObtienePendientes/Todo`,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // --------------------------------------------------------------------
  // NAVEGACIÓN
  // --------------------------------------------------------------------

  const cargar = useCallback(() => {
    window.location.href = "/#/CargaTesoreria";
  }, []);

  // --------------------------------------------------------------------
  // EMITIR CERTIFICADO
  // --------------------------------------------------------------------

  const EmitirValid = useCallback((row) => {
    Swal.fire({
      title: "Generando Certificado...",
      text: "Espere un momento.",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    axios({
      auth: AUTH,
      method: "post",
      url: `${API_URL}/CreaCertificadoSend`,

      data: {
        id: row.getValue("id"),
        id_certificado: row.getValue("id_certificado"),
        modulo: row.getValue("modulo"),
        numero_certificado: row.getValue("numero_certificado"),
        correo: row.getValue("correo"),
        envio_correo: "1",
        documento: row.getValue("documento"),
        nombre: row.getValue("nombre"),
        asistio: row.getValue("asistio"),
        certificado: row.getValue("certificado"),
        certidicado_ingles: row.getValue("certificado_ingles"),
        alcance: row.getValue("alcance"),
        alcance_ingles: row.getValue("alcance_ingles"),
        intensidad: row.getValue("intensidad"),
        listado_cursos: row.getValue("listado_cursos"),
        regional: row.getValue("regional"),
        ciudad: row.getValue("ciudad"),
        pais: row.getValue("pais"),
        fecha_certificado: row.getValue("fecha_certificado"),
        fecha_aprobacion: row.getValue("fecha_aprobacion"),
        fecha_ultima_modificaion: row.getValue("fecha_ultima_modificacion"),
        fecha_renovacion: row.getValue("fecha_renovacion"),
        fecha_vencimiento: row.getValue("fecha_vencimiento"),
        fecha_impresion: row.getValue("fecha_impresion"),
        direccion: row.getValue("direccion"),

        dato_1: row.getValue("dato_1"),
        dato_2: row.getValue("dato_2"),
        dato_3: row.getValue("dato_3"),
        dato_4: row.getValue("dato_4"),
        dato_5: row.getValue("dato_5"),
        dato_6: row.getValue("dato_6"),
        dato_7: row.getValue("dato_7"),
        dato_8: row.getValue("dato_8"),
        dato_9: row.getValue("dato_9"),
        dato_10: row.getValue("dato_10"),
        dato_11: row.getValue("dato_11"),
        dato_12: row.getValue("dato_12"),
        dato_13: row.getValue("dato_13"),
        dato_14: row.getValue("dato_14"),
        dato_15: row.getValue("dato_15"),

        estado: "",
        emitido: "Interno",

        dato_16: row.getValue("dato_16"),
        dato_17: row.getValue("dato_17"),
        dato_18: row.getValue("dato_18"),
        dato_19: row.getValue("dato_19"),
        dato_20: "Aprobado",
      },
    })
      .then((Response) => {
        console.log(Response.data);

        Swal.fire({
          title: "Certificado generado",
          text: "El certificado fue generado correctamente.",
          icon: "success",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#0085CA",
        }).then(() => {
          window.location.reload("/");
        });
      })
      .catch((error) => {
        console.log(error);

        Swal.fire({
          title: "Error",
          text: `Error al actualizar: ${error}`,
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      });
  }, []);

  // --------------------------------------------------------------------
  // ELIMINAR
  // --------------------------------------------------------------------

  const Elimina = useCallback((row) => {
    Swal.fire({
      title: "¿Eliminar pendiente?",
      text: "Esta acción eliminará el registro seleccionado.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#6c757d",
    }).then((result) => {
      if (!result.isConfirmed) return;

      axios({
        auth: AUTH,
        method: "delete",
        url: `${API_URL}/ElminaPendiente/${row.getValue("id")}`,
        data: {},
      })
        .then((Response) => {
          console.log(Response.data);

          Swal.fire({
            title: "Eliminado",
            text: "El registro fue eliminado correctamente.",
            icon: "success",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#0085CA",
          }).then(() => {
            window.location.reload("/");
          });
        })
        .catch((error) => {
          console.log(error);

          Swal.fire({
            title: "Error",
            text: `Error al actualizar: ${error}`,
            icon: "error",
            confirmButtonText: "Aceptar",
          });
        });
    });
  }, []);

  // --------------------------------------------------------------------
  // COLUMNAS
  // --------------------------------------------------------------------

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        enableEditing: false,
      },
      {
        accessorKey: "id_certificado",
        header: "ID Certificado",
        enableEditing: false,
      },
      {
        accessorKey: "modulo",
        header: "Módulo",
      },
      {
        accessorKey: "numero_certificado",
        header: "N.º Certificado",
      },
      {
        accessorKey: "correo",
        header: "Correo",
      },
      {
        accessorKey: "envio_correo",
        header: "Envío Correo",
      },
      {
        accessorKey: "documento",
        header: "Documento",
      },
      {
        accessorKey: "nombre",
        header: "Nombre",
      },
      {
        accessorKey: "asistio",
        header: "Asistió",
      },
      {
        accessorKey: "certificado",
        header: "Certificado",
      },
      {
        accessorKey: "certificado_ingles",
        header: "Certificado Inglés",
      },
      {
        accessorKey: "alcance",
        header: "Alcance",
      },
      {
        accessorKey: "alcance_ingles",
        header: "Alcance Inglés",
      },
      {
        accessorKey: "intensidad",
        header: "Intensidad",
      },
      {
        accessorKey: "listado_cursos",
        header: "Listado Cursos",
      },
      {
        accessorKey: "ciudad",
        header: "Ciudad",
      },
      {
        accessorKey: "pais",
        header: "País",
      },
      {
        accessorKey: "fecha_certificado",
        header: "Fecha Certificado",
      },
      {
        accessorKey: "fecha_aprobacion",
        header: "Fecha Aprobación",
      },
      {
        accessorKey: "fecha_ultima_modificacion",
        header: "Última Modificación",
      },
      {
        accessorKey: "fecha_renovacion",
        header: "Fecha Renovación",
      },
      {
        accessorKey: "fecha_vencimiento",
        header: "Fecha Vencimiento",
      },
      {
        accessorKey: "fecha_impresion",
        header: "Fecha Impresión",
      },
      {
        accessorKey: "direccion",
        header: "Dirección",
      },

      ...Array.from({ length: 15 }, (_, index) => ({
        accessorKey: `dato_${index + 1}`,
        header: `Dato ${index + 1}`,
      })),

      {
        accessorKey: "estado",
        header: "Estado",
        Cell: ({ cell }) => {
          const value = cell.getValue();

          return (
            <Chip
              label={value || "Pendiente"}
              size="small"
              color={value === "Emitido" ? "success" : "warning"}
              variant="soft"
              sx={{
                fontWeight: 600,
              }}
            />
          );
        },
      },

      {
        accessorKey: "emitido",
        header: "Emitido",
      },

      ...Array.from({ length: 5 }, (_, index) => ({
        accessorKey: `dato_${index + 16}`,
        header: `Dato ${index + 16}`,
      })),

      {
        accessorKey: "regional",
        header: "Regional",
      },
    ],
    [],
  );

  // --------------------------------------------------------------------
  // GUARDAR EDICIÓN
  // --------------------------------------------------------------------

  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    axios({
      auth: AUTH,
      method: "put",
      url: `${API_URL}/ValidaCertificado?Id=${values.id}`,
      data: values,
    })
      .then((Response) => {
        console.log(Response.data);

        alert(Response.data);

        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);

        alert(`Error al Actualizar ${error}`);
      });

    exitEditingMode();

    console.log("post data");
    console.log(values.id);
  };

  // --------------------------------------------------------------------
  // COLUMNAS OCULTAS
  // --------------------------------------------------------------------

  const hiddenColumns = useMemo(
    () => ({
      dato_1: false,
      dato_2: false,
      dato_3: false,
      dato_4: false,
      dato_5: false,
      dato_6: false,
      dato_7: false,
      dato_8: false,
      dato_9: false,
      dato_10: false,
      dato_11: false,
      dato_12: false,
      dato_13: false,
      dato_14: false,
      dato_15: false,
      dato_16: false,
      dato_17: false,
      dato_18: false,
      dato_19: false,
      dato_20: false,

      id_certificado: false,
      id: false,
      modulo: false,
      envio_correo: false,
      asistio: false,
      certificado_ingles: false,
      alcance: false,
      alcance_ingles: false,
      intensidad: false,
      listado_cursos: false,
      fecha_aprobacion: false,
      fecha_ultima_modificacion: false,
      fecha_renovacion: false,
      fecha_vencimiento: false,
      fecha_impresion: false,
      emitido: false,
    }),
    [],
  );

  // --------------------------------------------------------------------
  // RENDER
  // --------------------------------------------------------------------

  return (
    <PageContainer>
      {/* ============================================================ */}
      {/* ENCABEZADO */}
      {/* ============================================================ */}

      <HeaderContainer>
        <HeaderTitle>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "#1C2733",
            }}
          >
            Gestión de Tesorería
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
            }}
          >
            Administración y emisión de certificados pendientes
          </Typography>
        </HeaderTitle>

        <Button
          variant="contained"
          startIcon={<CloudUploadOutlined />}
          onClick={cargar}
          sx={{
            minHeight: 44,
            px: 2.5,
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 600,

            background: "linear-gradient(90deg, #006FA8 0%, #0085CA 100%)",

            boxShadow: "0 6px 16px rgba(0, 133, 202, 0.22)",

            "&:hover": {
              background: "linear-gradient(90deg, #005B8F 0%, #0074B3 100%)",

              transform: "translateY(-1px)",

              boxShadow: "0 8px 20px rgba(0, 133, 202, 0.30)",
            },

            transition: "all 0.2s ease",
          }}
        >
          Cargar Anexos
        </Button>
      </HeaderContainer>

      {/* ============================================================ */}
      {/* TABLA */}
      {/* ============================================================ */}

      <Box
        sx={{
          borderRadius: "16px",
          overflow: "hidden",

          backgroundColor: "#fff",

          border: "1px solid",
          borderColor: alpha("#0085CA", 0.08),

          boxShadow: "0 8px 30px rgba(31, 45, 61, 0.07)",
        }}
      >
        <MaterialReactTable
          localization={MRT_Localization_ES}
          columns={columns}
          data={list1}
          enableStickyHeader
          enableStickyFooter
          enableRowActions
          enableEditing
          editingMode="modal"
          onEditingRowSave={handleSaveRow}
          initialState={{
            columnVisibility: hiddenColumns,

            density: "comfortable",

            showColumnFilters: true,

            pagination: {
              pageSize: 10,
              pageIndex: 0,
            },
          }}
          muiTablePaperProps={{
            elevation: 0,

            sx: {
              borderRadius: 0,
              backgroundColor: "transparent",
            },
          }}
          muiTableContainerProps={{
            sx: {
              maxHeight: "calc(100vh - 270px)",

              "&::-webkit-scrollbar": {
                width: 8,
                height: 8,
              },

              "&::-webkit-scrollbar-thumb": {
                backgroundColor: alpha("#0085CA", 0.25),
                borderRadius: 10,
              },

              "&::-webkit-scrollbar-track": {
                backgroundColor: alpha("#0085CA", 0.04),
              },
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              backgroundColor: "#F4F8FA",

              color: "#334155",

              fontWeight: 700,

              fontSize: "0.78rem",

              borderBottom: "1px solid rgba(0,0,0,0.08)",

              "& .Mui-TableHeadCell-Content": {
                justifyContent: "space-between",
              },
            },
          }}
          muiTableBodyCellProps={{
            sx: {
              fontSize: "0.82rem",

              color: "#475569",

              borderBottom: "1px solid rgba(0,0,0,0.04)",
            },
          }}
          muiTableBodyRowProps={({ row }) => ({
            sx: {
              transition: "background-color 0.15s ease",

              "&:hover": {
                backgroundColor: alpha("#0085CA", 0.035),
              },

              ...(row.getValue("estado") === "Emitido" && {
                backgroundColor: alpha("#2E7D32", 0.025),
              }),
            },
          })}
          muiTopToolbarProps={{
            sx: {
              backgroundColor: "#fff",

              borderBottom: "1px solid rgba(0,0,0,0.06)",

              px: 2,
              py: 1,
            },
          }}
          muiBottomToolbarProps={{
            sx: {
              backgroundColor: "#fff",

              borderTop: "1px solid rgba(0,0,0,0.06)",
            },
          }}
          muiSearchTextFieldProps={{
            size: "small",

            placeholder: "Buscar...",

            sx: {
              minWidth: {
                xs: 180,
                md: 260,
              },

              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
              },
            },
          }}
          renderDetailPanel={({ row }) => (
            <Box
              sx={{
                p: 2,

                backgroundColor: "#F8FAFC",

                borderTop: "1px solid rgba(0,0,0,0.04)",
              }}
            >
              <Box
                sx={{
                  display: "grid",

                  gridTemplateColumns: {
                    xs: "1fr",
                    md: "1fr 1fr",
                  },

                  gap: 2,

                  p: 2,

                  borderRadius: "12px",

                  backgroundColor: "#fff",

                  border: "1px solid rgba(0,0,0,0.06)",
                }}
              >
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "text.secondary",
                      fontWeight: 600,
                    }}
                  >
                    Alcance
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      mt: 0.5,
                      color: "#334155",
                    }}
                  >
                    {row.original.alcance || "Sin información"}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "text.secondary",
                      fontWeight: 600,
                    }}
                  >
                    Certificado
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      mt: 0.5,
                      color: "#334155",
                    }}
                  >
                    {row.original.certificado || "Sin información"}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}
          renderRowActions={({ row }) => {
            const isEmitido = row.getValue("estado") === "Emitido";

            if (isEmitido) {
              return null;
            }

            return (
              <Stack direction="row" spacing={0.5} alignItems="center">
                <Tooltip arrow placement="top" title="Emitir certificado">
                  <IconButton
                    size="small"
                    onClick={() => EmitirValid(row)}
                    sx={{
                      width: 36,
                      height: 36,

                      color: "#0085CA",

                      backgroundColor: alpha("#0085CA", 0.08),

                      "&:hover": {
                        backgroundColor: alpha("#0085CA", 0.16),

                        transform: "translateY(-1px)",
                      },

                      transition: "all 0.2s ease",
                    }}
                  >
                    <SendAndArchiveSharp fontSize="small" />
                  </IconButton>
                </Tooltip>

                <Tooltip arrow placement="top" title="Eliminar pendiente">
                  <IconButton
                    size="small"
                    onClick={() => Elimina(row)}
                    sx={{
                      width: 36,
                      height: 36,

                      color: "#D32F2F",

                      backgroundColor: alpha("#D32F2F", 0.07),

                      "&:hover": {
                        backgroundColor: alpha("#D32F2F", 0.14),

                        transform: "translateY(-1px)",
                      },

                      transition: "all 0.2s ease",
                    }}
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Stack>
            );
          }}
        />
      </Box>
    </PageContainer>
  );
};

export default InfoTesoreria;
